import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=79fd52a8&scoped=true&lang=pug"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=79fd52a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd52a8",
  null
  
)

export default component.exports